import React from "react";
import { Modal, notification, Form, Input } from "antd";
import { useMutation } from "@apollo/react-hooks";
import { engGql } from "../../graphql/engagement";
import { defaultFormLayout } from "../../common/Utils";
import { GradePicker } from "../../components/GradePicker";
import { ActivityTypeSelect } from "./components/ActivityTypeSelect";

export const ToolWorkSubmissionDlg = ({ onClose, model }) => {
  const [form] = Form.useForm();
  const [saveEngToolWorkSubmission, { loading: saving }] = useMutation(engGql.saveEngToolWorkSubmission);

  const save = () => {
    form.validateFields().then((values) => {
      const { id } = model;
      saveEngToolWorkSubmission({
        variables: { input: { id, ...values } },
      })
        .then((res) => {
          notification.success({ message: `activity saved` });
          onClose(true);
        })
        .catch((err) => {});
    });
  };

  return (
    <Modal
      title="Work Submission"
      visible={true}
      onOk={() => save()}
      maskClosable={false}
      confirmLoading={saving}
      onCancel={() => onClose()}
      width={900}
    >
      <Form {...defaultFormLayout} form={form} initialValues={{ ...model, grades: model.grades || [] }} size="small">
        <Form.Item
          name="activityType"
          label="Activity Type"
          rules={[{ required: true, message: "Please select activity type" }]}
        >
          <ActivityTypeSelect />
        </Form.Item>
        <Form.Item name="title" label="Title" rules={[{ required: true, message: "Please enter title" }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Grade Range" name="grades">
          <GradePicker />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Please enter description" }]}
        >
          <Input.TextArea rows={5} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
